<template lang="pug">
    .main__section
        .main__section-img-wr
            img.main__section-img(:src="section2.image.path" :alt="section2.image.name" v-show='!imgHide')
        .main__section-block
            h2.main__section-headline.main__section-headline--big(v-html='section2.subtitle')
            .main__section-scroll.main__section-scroll-1
                .main__section-scroll-wr
                    h4.main__section-subtitle(v-html='section2.description')
                    ul.main__section-list
                        li.main__section-list-item(v-for="item in section2.servicesList")
                            router-link(:to="item.link") {{ item.name }}
            router-link.main__section-button(:to="section2.buttonLink")
                p Оставить заявку на
                p проведение исследования
</template>

<script>
    import EventBus from '@/eventBus';
    import {ScrollbarHelpers} from "@/mixins/ScrollbarHelpers";


    export default {
        name: 'SectionTwo',

        mixins: [ ScrollbarHelpers ],

        props: ['section2'],

        data() {
            return {
                content: null,
                imgHide: true,
                windowWidth: 0
            }
        },

        components: {
        },

        created() {
            this.windowWidth = $(window).width();
            EventBus.$on('imgLoaded', (res) => {
                this.imgHide = res;
            });
            this.$nextTick(() => {
                if(this.windowWidth > 760) {
                    this.customScrollbarInit('.main__section-scroll-1');
                }
            });
        },

        methods: {

        }

    }
</script>
